import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Cookies from 'universal-cookie';

export default function AlertDialog() {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    const cookies = new Cookies();
    cookies.set('disclaimer', 'confirmed', { path: '/' });
  };

  return (
    <div>
      <Dialog
        open={open}
        disableBackdropClick
        disableEscapeKeyDown
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{""}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Seznanjen sem, da:
            <ul>
                <li>je Pregledovalnik dostopnosti prostora  v testni fazi,</li>
                <li>so podatki o dostopnosti v fazi dopolnjevanja in se periodično posodabljajo,</li>
                <li>podatki v Pregledovalniku lahko odstopajo od dejanskega stanja.</li>
            </ul>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="outlined">
            V redu
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
